import {lazyRegister} from '@/Core/lazyRegister';
import {BaseApiFactory} from "@/Factories/BaseApiFactory";
import {AcceptRatingMail} from "@/models";

export class RatingEmailService {
    static $inject = ['BaseApiFactory'];

    constructor(private baseApiFactory: BaseApiFactory) {
    }

    GetList(query: any) {
        return this.baseApiFactory.getData<AcceptRatingMail[]>('/api/AcceptRatingMail', query);
    }
}

lazyRegister.service('RatingEmailService', RatingEmailService);
